// extracted by mini-css-extract-plugin
module.exports = {"badge":"Badge_badge__AQuHQ","badge--primary":"Badge_badge--primary__5zst9","badge--secondary":"Badge_badge--secondary__HrcMx","badge--disabled":"Badge_badge--disabled___qPLt"};